import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import { transformResultsFromObjectSplitByVendor } from 'util/data';
import { vendorCodes } from 'modules/store/vendors';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE} from 'util/constants';

const name = 'azrProducts',
    exports = storeModuleFactory({
        name,
        endpoint:           endpoints.azrProducts.endpoint,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_BIG,
        instanceEndpoint:   endpoints.azrProducts.instanceEndpoint,
        transformResultsFn: json => transformResultsFromObjectSplitByVendor(json.results, vendorCodes.azure)
    });

module.exports = exports;



// WEBPACK FOOTER //
// ./src/modules/store/azrProducts.js